const pad = (n) => String(n).padStart(2, "0");
const HOURS = Array.from({ length: 24 }, (_, i) => pad(i));
const MINS = Array.from({ length: 12 }, (_, i) => pad(i * 5));
const SEL = "h-10 rounded-md border bg-background px-2 font-mono text-sm";

export const TimeInput24 = ({ value, onChange, testid }) => {
  const [h, m] = (value || "00:00").split(":");
  const mins = MINS.includes(m) ? MINS : [...MINS, m].sort();
  return (
    <div className="flex items-center gap-1" data-testid={testid}>
      <select aria-label="Hour" value={h} onChange={(e) => onChange(`${e.target.value}:${m}`)} className={SEL} data-testid={`${testid}-hour`}>
        {HOURS.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
      <span className="font-bold">:</span>
      <select aria-label="Minute" value={m} onChange={(e) => onChange(`${h}:${e.target.value}`)} className={SEL} data-testid={`${testid}-minute`}>
        {mins.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
    </div>
  );
};

export const DateTimeInput24 = ({ value, onChange, testid }) => {
  const [d, t] = value.split("T");
  return (
    <div className="space-y-2">
      <input type="date" value={d} onChange={(e) => e.target.value && onChange(`${e.target.value}T${t}`)} className={`${SEL} w-full`} data-testid={`${testid}-date`} />
      <TimeInput24 value={t} onChange={(nt) => onChange(`${d}T${nt}`)} testid={`${testid}-time`} />
    </div>
  );
};
